import { gql } from '@apollo/client';

import { GRAPHQL } from '../../constants';

export default gql`
    fragment commonQuestionsFields on CommonQuestions {
        title
        summary: summaryRaw
        ${GRAPHQL.IMAGE_OBJECT}
        questions {
          question
          answerRaw
        }
    }
`;
